import { OpPatch } from "json-patch";
import { TypeVacina } from "../../../Models/Domain/Saude/Vacina";
import { Axios } from "../../Axios";

export interface IFiltro {
    codigo?: number,
    nome?: string,
    ativo?: boolean
}

export class VacinaService {
    public static listar(filtro?: IFiltro){
        return Axios.get<TypeVacina[]>(`quiron/saude/vacina`, {params: filtro});
    }

    public static atualizar(payload: TypeVacina){
        return Axios.put<void>(`quiron/saude/vacina`, payload);
    }

    public static atualizarComPatch(codigo: number, payload: OpPatch){
        return Axios.patch<void>(`quiron/saude/vacina/${codigo}`, payload);
    }

    public static inserir(payload: TypeVacina){
        return Axios.post<void>(`quiron/saude/vacina`, payload);
    }

    public static desativar(codigo: number){
        return Axios.patch<void>(`quiron/saude/vacina/${codigo}/desativar`);
    }

    public static ativar(codigo: number){
        return Axios.patch<void>(`quiron/saude/vacina/${codigo}/ativar`);
    }
}